export const TYPE_ITEMS = [
    { type: 'Facebook', url: 'https://www.facebook.com/'},
    { type: 'Instagram', url: 'https://www.instagram.com/'},
    { type: 'YouTube', url: 'https://www.youtube.com/@'},
    { type: 'LinkedIn', url: 'https://www.linkedin.com/company/'},
    { type: 'Twitter', url: 'https://twitter.com/'},
    { type: 'TikTok', url: 'https://www.tiktok.com/@'},
]